import React from 'react';
import {
    Box,
    Button,
    DataList,
    DataItem,
    IconButton,
    Menu,
    MenuContent,
    MenuTrigger,
    MenuItem,
    HStack,
    Icon,
} from '@cad-arc';
import type { AttachmentSortOptionValue } from './types';
import { ATTACHMENT_SORT_OPTIONS } from './constants';

interface AttachmentsHeaderActionsProps {
    onUploadClick: () => void;
    isUploadDisabled: boolean;
    sortOption: AttachmentSortOptionValue;
    onSortChange: (sortOption: AttachmentSortOptionValue) => void;
    showSortOption?: boolean;
}

export function AttachmentsHeaderActions({
    onUploadClick,
    isUploadDisabled,
    sortOption,
    onSortChange,
    showSortOption,
}: AttachmentsHeaderActionsProps): React.ReactElement {
    return (
        <HStack spacing={2}>
            <Button
                size="sm"
                onClick={onUploadClick}
                disabled={isUploadDisabled}
                data-testid="attachment-upload-button"
            >
                <Icon icon="Upload" /> Upload
            </Button>
            {showSortOption && (
                <Menu>
                    <MenuTrigger>
                        <IconButton
                            icon="Filter"
                            variant="ghost"
                            size="sm"
                            aria-label="sort attachments"
                            data-testid="attachment-sort-button"
                        />
                    </MenuTrigger>
                    <MenuContent>
                        <Box p={2} fontWeight="bold" fontSize="sm">
                            Sort
                        </Box>
                        {ATTACHMENT_SORT_OPTIONS.map((option) => (
                            <MenuItem
                                key={option.value}
                                onClick={() => onSortChange(option.value)}
                                style={{
                                    padding: '8px 12px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                }}
                                data-testid={`attachment-sort-option-${option.value}`}
                            >
                                <DataList>
                                    <DataItem
                                        dataKey={
                                            <>
                                                {sortOption === option.value && (
                                                    <Icon icon="Check" size="sm" />
                                                )}
                                                {option.category}:
                                            </>
                                        }
                                    >
                                        {option.label}
                                    </DataItem>
                                </DataList>
                            </MenuItem>
                        ))}
                    </MenuContent>
                </Menu>
            )}
        </HStack>
    );
}
